import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Hi, I'm Daniel Moya`}</h2>
    <p>{`I’m a Systems Engineer with 5 years of office and remote work experience in the financial, mobility, e-learning, and SaaS industry. I’m proficient in web and mobile development (Git, Github, Gitlab), frontend (Html, Css, Javascript, Typescript, React, React Native, Android, iOS), backend (NodeJS, Php, Symphony, Docker), databases (MySQL, MariaDB, Postgresql, MongoDB), testing (Jest, Cypress, Php unit, Codeception, Selenium), DevOps (CircleCi, Github Actions) and cloud solutions (Firebase, GCP, AWS). I have experience working in agile environments to collectively build, improve, and maintain stable software solutions turning legacy applications into modern architectures, while keeping code quality.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      